module.exports = __webpack_public_path__ + "static/gallery36-533c9f15ae1f379c0ac1688963025cc0.jpg";